<template>
  <a
    class="communication-channel-item"
    :href="`tel:${settings.phone}`"
  >
    <div class="communication-channel-item__logo" />
  </a>
</template>

<script lang="ts">
export default defineComponent({
  name: 'PhoneChannel',

  props: {
    settings: {
      type: Object,
      default: () => ({}),
    },
  },
});
</script>

<style lang="scss" scoped>
.communication-channel-item {
  &__logo {
    background-image: url('./images/phone.svg');
    width: 24px;
    height: 24px;
  }
}
</style>
